/**
 * @Des 新增/编辑 账户 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <div v-if="dialogForm.dialogFormVisible">
    	<el-dialog :title="dialogForm.title"
	               :visible.sync="dialogForm.dialogFormVisible"
	               :close-on-click-modal="false"
	               custom-class="form-dialog"
	               v-dialogDrag
	               class="dialog_title"
	               @close="handleDialogClose"
	    >
            <div id="trackLine" style="width: 100%;height: 100%;"></div>

	    </el-dialog>
    </div>
</template>

<script>
	
	export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'LocationTrackAnalysis',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
        },
        mounted() {
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    title: "",
                    dialogFormVisible: false,
                },
                
                /**
                 * @Des 图表数据
                 * @Auth
                 * @Date 2021/6/19
                 */
                chartFilters: {
                	time: [],
                	x: [],
                	y: [],
                },
                // 图表对象
                myChart: null,
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(bindingType, trackObj, trackInfos){
                this.dialogForm.dialogFormVisible = true;
                if(bindingType == 1){
                    this.dialogForm.title =  trackObj.userName + "的轨迹数据分析";
                }else if(bindingType == 2){
                    this.dialogForm.title =  trackObj.carNumber + "的轨迹数据分析";
                }else if(bindingType == 3){
                    this.dialogForm.title =  trackObj.toolName + "的轨迹数据分析";
                }
				
				// 重置表单
                this.reset();
				
                let time = [];
                let x = [];
                let y = [];
                trackInfos.forEach((row,index) => {
                    time.push(row.time);
                    x.push(row.rX);
                    y.push(row.rY);
                })
				
				// 图表数据
				this.chartFilters.time = time;
				this.chartFilters.x = x;
				this.chartFilters.y = y;
				
                // 延时执行
                this.$nextTick(() => {
                	// 初始化图表
                	this.initMyChart();
                });
            },
            
            /**
	         * @Des 初始化图表
	         * @Auth
	         * @Date 2021/6/19
	         */
	        initMyChart() {
	        	this.myChart = this.$echarts.init(document.getElementById('trackLine'));
                this.option = {
                    title: {
                        text: '',
                        subtext: ''
                    },
					/*grid: {
						left: '6%',
						right: '8%',
						bottom: '5%',
						top: '10%',
						containLabel: true
					},*/
                    // tooltip，鼠标放到折线图上展示的数据展示样式
                    tooltip: {
                        trigger: 'axis'
                    },
                    //  //鼠标hover到最顶部的legend标志，可以标志对应的折线图，点击legend标志会隐藏对应的折线图
                    legend: {
                        data: ['坐标X', '坐标Y'],
                        top: '10px',
                    },
                    backgroundColor: '#FBFBFB',
                    toolbox: {
                        show: false,
                        feature: {
                            dataZoom: {
                                yAxisIndex: 'none'
                            },
                            dataView: {readOnly: false},
                            magicType: {type: ['line', 'bar']},
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    // 配置x轴数据、样式、名称
                    xAxis:  {
                        type: 'category',
                        boundaryGap: false,
                        data: this.chartFilters.time,     // x轴数据
                        name: '时间',
                        // x轴名称样式
                        nameTextStyle: {
                            fontWeight: 600,
                            fontSize: 18
                        }
                    },
                    // 配置y轴名称，样式
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                        name: '坐标（米）',
                        nameTextStyle: {
                            fontWeight: 600,
                            fontSize: 18
                        }
                    },
                    series: [
                        {
                            name: '坐标X',
                            type: 'line',
                            data: this.chartFilters.x,
                            symbolSize: 8,//拐点大小
                            itemStyle: {
				            	normal: {
				            		/*color: function (params) {
				            			var colorList = [
				            				'#2196F3', '#009688', '#8BC34A'
				            			];
				            			return colorList[params.dataIndex];
				            		},*/
				            		color:'#2196F3',
				            		lineStyle:{  
                                        color:'#2196F3',
                                        borderColor: '#2196F3',
//                                      width: 2,
                                    },
				            	}
				            },
                        },
                        {
                            name: '坐标Y',
                            type: 'line',
                            data: this.chartFilters.y,
                            symbolSize: 8,//拐点大小
                            itemStyle: {
				            	normal: {
				            		/*color: function (params) {
				            			var colorList = [
				            				'#2196F3', '#009688', '#8BC34A'
				            			];
				            			return colorList[params.dataIndex];
				            		},*/
				            		color:'#ff455b',
				            		lineStyle:{  
                                        color:'#ff455b',
                                        borderColor: '#ff455b',
//                                      width: 2,
                                    }
				            	}
				            },
                        }
                    ]
                };
				this.myChart.setOption(this.option);
	        },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
                this.dialogForm.dialogFormVisible = false;
                // 数据重置
                this.reset();
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	        	// 图表数据
				this.chartFilters.time = [];
				this.chartFilters.x = [];
				this.chartFilters.y = [];
                // 图表对象
                this.myChart = null;
	        },


        },// methods
    }
</script>
/* JS */

/* CSS */
<style scoped>
    *{
        box-sizing: border-box;
    }

    /deep/ .el-dialog {
    	width: 90%;
    	height: calc(100% - 15vh - 50px);
    }
    .dialog_title{
        text-align: left;
        margin-top: -10vh;
    }
    /deep/ .el-dialog__body {
    	height: calc(100% - 74px);
    }
/*
    /deep/ .el-dialog__header .el-dialog__title{
        font-size: 16px;
    }

    /deep/ .el-form-item__label{
        font-size: 14px;
    }
    /deep/ .el-dialog__body{
        height: 100%;
        padding: 20px;
        position: relative;
    }
    /deep/ .el-form-item{
        margin-bottom: 20px;
    }
    /deep/ .el-form-item:last-child{
        margin-bottom: 15px;
    }

    /deep/ .el-form-item__content {
    	max-width:300px;
    }
    /deep/ .el-input {
    	width: 100% !important;
    }

    /deep/ .numberScreening {
    	border-color: #DCDFE6;
    }
    /deep/ .aaa {
    	border-bottom-color: #DCDFE6;
    }*/

    /*========= form 上下结构 start =========*/
    /*========= 头像 start =========*/
    .image-form-item {
	    width: 120px;
	    position: absolute;
	    right: 20px;
	    top: 20px;
	    /*padding-top: 25px;*/

	   color: #e6e6e6;
    }
    .image-item-title {
        width: 100%;
    	display: block;
    	line-height: 20px;
    	text-align: center;
    	margin-top: 5px;
    	background: #3f51b5;
    	color: #e6e6e6;
    }
    button.image-item-title {
    	cursor: pointer;
    	border: none;

    	transition: all 0.4s;
    }
    button.image-item-title:hover {
    	background-color: #222285;
    	color: #ffffff;
    }
    .image-item-box {
    	width: 100%;
    	height: 120px;
    	border: 1px solid #DCDFE6;
	    border-radius: 4px;

	    text-align: center;
	    line-height: 118px;
	    /*cursor: pointer;*/
	    position: relative;

	    transition: all 0.4s;
    }
    .image-item-box:hover {
    	border-color: #ffffff;
    	background-color: #222285;
    }
    .image-item-box img {
    	height: auto;
    	width: auto;
    	max-height: 110px;
    	max-width: 110px;
    	display: block;

    	margin: auto;
	    position: absolute;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    right: 0;
    }
    .image-item-box .noImgItem {
    	font-size: 60px;
		display: none;
		line-height: 2;

		margin: auto;
	    position: absolute;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    right: 0;
    }

    .image-item-box.none-item img {
    	display: none;
    }
    .image-item-box.none-item .noImgItem {
    	display: block;
    }

    .camara-pre-view {
    	display: none;
    }
    .camara-pre-view.on {
    	display: block;
    }
    /*========= 头像 end =========*/

    /deep/ .el-form-item__label {
    	line-height: 20px;
        z-index: 1;
		position: relative;
    }
    .el-form-item {
    	float: left;
    	margin-bottom: 15px;
    }
    .row-items-1 {
    	width: calc((100% - 120px));
    }
    .row-items-2 {
    	width: calc((100% - 120px) / 2);
    }
    .row-items-3 {
    	width: calc((100% - 120px) / 3);
    }
    /deep/ .el-form-item__content {
    	max-width: calc(100% - 20px);
    }
    .el-select {
    	width: 100%;
    }
    .phone-code-select {
    	width: 80px;
    	position: absolute;
    	z-index: 1;
    }
    /deep/ .phone-item-input .el-input__inner {
    	padding-left: 95px;
    }
    /*========= form 上下结构 end =========*/

    /deep/ .rt-input .el-input__inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .rt-input .el-textarea__inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .rt-input .el-input__suffix-inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .el-button{
        background-color: #5f610c;
    }

    /deep/ .el-button:hover {
        background: #222285;
    }

</style>



// WEBPACK FOOTER //
// src/components_pages/Location/LocationTrackAnalysis.vue